import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ManageDepartmentsService } from 'src/app/private/services/manage-departments.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-manage-departments',
  templateUrl: './manage-departments.component.html',
  styleUrls: ['./manage-departments.component.scss']
})
export class ManageDepartmentsComponent implements OnInit {

  displayedColumns: string[] = ['dept_name', 'description', 'action'];
  dataSource = new MatTableDataSource<any>();
  isLoading = false;
  btnLoading = false;
  formAction = 'Add';
  selectedDepartment: any = {};
  department: Department = new Department();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private api: ManageDepartmentsService,
    private modalService: NgbModal,
    private toast: ToastrService,
    private localStorage: LocalStorageService
  ) { }

  ngOnInit(): void {
    this.loadDepartments();
  }

  loadDepartments() {
    this.isLoading = true;
    const param = {
      where: {
        client_id: this.localStorage.getClientId()
      }
    };
    this.api.getAllDepartment(param).subscribe({
      next: (res: any) => {
        this.dataSource.data = res || [];
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error(err);
        this.toast.error('Error loading departments');
      }
    });
  }

  open(content: any, dept: any = null) {
    if (dept) {
      this.formAction = 'Edit';
      this.department = { ...dept }; 
    } else {
      this.formAction = 'Add';
      this.department = new Department();
      this.department.client_id = this.localStorage.getClientId();
    }
    this.modalService.open(content, { size: 'lg', centered: true });
  }

  save() {
    if (!this.department.dept_name) {
      this.toast.error('Department Name is required');
      return;
    }

    this.btnLoading = true;
    
    // Ensure client_id is set
    this.department.client_id = this.localStorage.getClientId();

    if (this.formAction === 'Add') {
      this.api.createDepartment(this.department).subscribe({
        next: () => {
          this.toast.success('Department created successfully');
          this.modalService.dismissAll();
          this.loadDepartments();
          this.btnLoading = false;
        },
        error: (err) => {
          this.toast.error(err.error?.msg || 'Error creating department');
          this.btnLoading = false;
        }
      });
    } else {
      this.api.updateDepartment(this.department).subscribe({
        next: () => {
          this.toast.success('Department updated successfully');
          this.modalService.dismissAll();
          this.loadDepartments();
          this.btnLoading = false;
        },
        error: (err) => {
          this.toast.error(err.error?.msg || 'Error updating department');
          this.btnLoading = false;
        }
      });
    }
  }

  deleteModal(content: any, dept: any) {
    this.selectedDepartment = dept;
    this.modalService.open(content, { centered: true });
  }

  deleteDepartment() {
    this.btnLoading = true;
    const param = {
      department_id: this.selectedDepartment.department_id
    };
    this.api.deleteDepartment(param).subscribe({
      next: () => {
        this.toast.success('Department deleted successfully');
        this.modalService.dismissAll();
        this.loadDepartments();
        this.btnLoading = false;
      },
      error: (err) => {
        this.toast.error(err.error?.msg || 'Error deleting department');
        this.btnLoading = false;
      }
    });
  }
}

export class Department {
  dept_id?: number;
  dept_name: string = "";
  description: string = "";
  is_public: boolean = false;
  center_id: any = null;
  client_id: any;
  status: string = "Active";
}
